<app-header [forceLightBackground]="true"></app-header>
<div class="profile-page">
  <div class="profile-page--layout">
    <app-consumer-sidebar class="profile-page--sidebar"></app-consumer-sidebar>
    <div class="profile-page--content">
      <app-page-header></app-page-header>
      
      <div class="profile-container">
        <app-profile></app-profile>
      </div>
    </div>
  </div>
</div>
